import * as api from "../api/classApi";
import { useQuery } from "@tanstack/react-query";

const keyPrefix = "classroomDetails";

export function useClassroomDetailsQuery(
	classroomId,
	includeStudents,
	includeTeachers,
	includeSchedule,
	includeRules,
	type,
	sourceId,
	teacherId,
	queryOptions = {}
) {
	const key = [keyPrefix, classroomId, includeStudents, includeTeachers, includeSchedule, includeRules, type, sourceId, teacherId];
	const query = useQuery(
		key,
		() => api.getClassroomDetails(classroomId, includeStudents, includeTeachers, includeSchedule, includeRules, type, sourceId, teacherId),
		queryOptions
	);
	return query;
}

export function makeClassroomDetailsInvalidationKey(classroomId) {
	return [keyPrefix, classroomId];
}
